var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 92,
    viewBox: "0 0 85 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.8911,
    cy: 11.6523,
    r: 10.9565,
    fill: "#4970FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.8914,
    cy: 88.348,
    r: 3.65217,
    fill: "#4970FC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.15217,
    cy: 49.3908,
    r: 3.65217,
    transform: "rotate(-90 4.15217 49.3908)",
    fill: "#4970FC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.8475,
    cy: 49.3908,
    r: 3.65217,
    transform: "rotate(-90 80.8475 49.3908)",
    fill: "#4970FC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4042,
    cy: 22.6089,
    r: 3.65217,
    transform: "rotate(-45 15.4042 22.6089)",
    fill: "#4970FC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.6366,
    cy: 76.8408,
    r: 3.65217,
    transform: "rotate(-45 69.6366 76.8408)",
    fill: "#4970FC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.8906,
    cy: 22.9037,
    r: 3.65217,
    transform: "rotate(45 69.8906 22.9037)",
    fill: "#4970FC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6582,
    cy: 77.1357,
    r: 3.65217,
    transform: "rotate(45 15.6582 77.1357)",
    fill: "#4970FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.7336c8ee297dac0ff689d825b9754d65.svg";
export { ForwardRef as ReactComponent };